import { getUserScopedStorageKey } from '@/utils/userScopedStorage'

const STORAGE_BASE = 'erp_mobile_nav_hidden_tabs_v1'

function storageKey() {
  return getUserScopedStorageKey(STORAGE_BASE)
}

/** @param {object | null | undefined} user */
export function isMobileNavConfigured(user) {
  return !!(user && user.mobile_nav_hidden_tabs != null)
}

/** @param {object | null | undefined} user @returns {Set<string>} */
export function getMobileNavHiddenTabIds(user) {
  if (isMobileNavConfigured(user)) {
    const arr = Array.isArray(user.mobile_nav_hidden_tabs) ? user.mobile_nav_hidden_tabs : []
    return new Set(arr.map((id) => String(id || '').trim()).filter(Boolean))
  }
  try {
    const raw = localStorage.getItem(storageKey())
    if (!raw) return new Set()
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return new Set()
    return new Set(parsed.map((id) => String(id || '').trim()).filter(Boolean))
  } catch {
    return new Set()
  }
}

/** @param {string[]} hiddenTabIds */
function saveMobileNavHiddenTabIdsLocal(hiddenTabIds) {
  const key = storageKey()
  const ids = [...new Set((hiddenTabIds || []).map((id) => String(id || '').trim()).filter(Boolean))]
  if (!ids.length) {
    localStorage.removeItem(key)
    return
  }
  localStorage.setItem(key, JSON.stringify(ids))
}

/**
 * 保存底栏显示偏好（服务端 + 本地备份）
 * @param {string[]} hiddenTabIds
 * @param {object | null | undefined} user
 */
export async function saveMobileNavHiddenTabIds(hiddenTabIds, user) {
  const ids = [...new Set((hiddenTabIds || []).map((id) => String(id || '').trim()).filter(Boolean))]
  saveMobileNavHiddenTabIdsLocal(ids)
  try {
    const request = (await import('@/utils/request')).default
    const res = await request({
      url: '/api/auth/me/mobile-nav',
      method: 'patch',
      data: { hidden_tab_ids: ids }
    })
    if (!res?.success) {
      throw new Error(res?.message || '保存底栏设置失败')
    }
    if (user) {
      user.mobile_nav_hidden_tabs = res.data?.hidden_tab_ids ?? ids
    }
    return res.data
  } catch (e) {
    const status = e?.response?.status
    if (status === 404 || status >= 500) {
      if (user) user.mobile_nav_hidden_tabs = ids
      return { hidden_tab_ids: ids, configured: true, offline: true }
    }
    throw e
  }
}

/** @param {string} tabId @param {object | null | undefined} user */
export function isMobileNavTabHiddenByUser(tabId, user) {
  const id = String(tabId || '').trim()
  if (!id) return false
  return getMobileNavHiddenTabIds(user).has(id)
}
